import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	popup: {
		maxWidth: 680,
		width: '90vw',
		maxHeight: '90vh',
		display: 'flex',
		flexDirection: 'column',
	},
	body: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		overflow: 'hidden',
		flex: 1,
		minHeight: 0,
	},
	// Flexed rather than `height: 100%`, which can't resolve here and drops the iframe to its 150px default.
	previewPanel: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
		minHeight: 200,
		border: `1px solid ${THEME.colors.border.main}`,
		borderRadius: THEME.common.borderRadius,
		overflow: 'hidden',
		backgroundColor: THEME.colors.background.light,
	},
	previewFrame: {
		flex: 1,
		width: '100%',
		border: 'none',
	},
	socialScroll: {
		flex: 1,
		minHeight: 0,
		overflowY: 'auto',
		...THEME.common.scrollBar,
	},
	blogScroll: {
		flex: 1,
		minHeight: 0,
		overflowY: 'auto',
		...THEME.common.scrollBar,
	},
	previewUnavailable: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flex: 1,
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
	},
	refineSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
	},
	refineLabel: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		fontWeight: THEME.typography.fontWeights.semibold,
	},
	refineRow: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		gap: THEME.spacing.sm,
	},
	refineField: {
		display: 'flex',
		alignSelf: 'stretch',
		flexDirection: 'column',
		gap: SPACE[4],
		minWidth: 0,
	},
	refineTextArea: {
		flex: 1,
		resize: 'none',
		minHeight: 60,
		maxHeight: 120,
	},
	errorText: {
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.danger.main,
		margin: 0,
	},
	footer: {
		display: 'flex',
		justifyContent: 'space-between',
	},
});
